<template>
	<div class="system-content">
		<div class="system-left">
			<p class="title">索赔管理</p>
			<el-menu :default-active="defaultActivePath" router>
				<menu-item v-for="(item, index) in menuList" :item="item" :key="index"></menu-item>
			</el-menu>
		</div>
		<div class="system-right" :class="className" :style="height">
			<transition name="fade-transform" mode="out-in">
				<router-view :key="key" />
			</transition>
		</div>
	</div>
</template>
<script>
// 路径常量
const PATHS = {
	REPAIR_REQUEST: "/claimantManagement/repairRequest",
	CLAIM_LIST: "/claimantManagement/claimApplicationList",
};
import MenuItem from "@/components/MenuItem";
export default {
	components: {
		MenuItem,
	},
	data() {
		return {
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			defaultActivePath: "",
			height: "",
			className: "p1",
			menuList: [],
			claimRoute: "/claimantManagement/claimApplicationList",
		};
	},
	computed: {
		key() {
			return this.$route.path;
		},
	},
	created() {
		this.init();
		// 处理路由重复点击报错问题
		this.handleRepeatRoute();
	},
	watch: {
		$route(from, to) {
			if (["claimApplicationList", "claimReviewList", "claimDeliveryList"].includes(from.name)) {
				const claimRoute = `/claimantManagement/${from.name}`;
				this.claimRoute = claimRoute;
				window.sessionStorage.setItem("claimRoute", claimRoute);
			}
			this.init();
			this.handleRepeatRoute();
		},
	},
	methods: {
		init() {
			this.height = "min-height:" + (window.innerHeight - 180) + "px;";
			let menuArray = [];
			// 常规索赔
			if (this.perms.includes("home:repair:normalRepair")) {
				let routeObj = {
					title: "常规索赔",
					icon: "el-icon-folder",
					path: "regular",
					children: [],
				};
				if (this.perms.includes("home:repair:normalRepair:apply")) {
					routeObj.children.push({
						title: "索赔申请",
						icon: "el-icon-edit-outline",
						name: "claimApplicationList",
						path: "/claimantManagement/claimApplicationList",
					});
				}
				if (this.perms.includes("home:repair:normalRepair:audit")) {
					routeObj.children.push({
						title: "资料审核",
						icon: "el-icon-reading",
						name: "claimReviewList",
						path: "/claimantManagement/claimReviewList",
					});
				}
				if (this.perms.includes("home:repair:normalRepair:shipping")) {
					routeObj.children.push({
						title: "索赔发货",
						icon: "el-icon-truck",
						name: "claimDeliveryList",
						path: "/claimantManagement/claimDeliveryList",
					});
				}
				if (this.perms.includes("home:repair:normalRepair:parts")) {
					routeObj.children.push({
						title: "索赔零件",
						icon: "el-icon-truck",
						name: "claimProductList",
						path: "/claimantManagement/claimProductList",
					});
				}
				if (this.perms.includes("home:repair:normalRepair:extended")) {
					routeObj.children.push({
						title: "延保信息",
						icon: "el-icon-document-copy",
						name: "extendedWarrantyInfo",
						path: "/claimantManagement/extendedWarrantyInfo",
					});
				}
				menuArray.push(routeObj);
			}
			// 特约索赔
			if (this.perms.includes("home:repair:specialRepair")) {
				let routeObj = {
					title: "特约索赔",
					icon: "el-icon-folder-opened",
					path: "special",
					children: [],
				};
				if (this.perms.includes("home:repair:apply")) {
					routeObj.children.push({
						title: "维修申请",
						icon: "el-icon-tickets",
						name: "repairRequest",
						path: "/claimantManagement/repairRequest",
					});
				}
				if (this.perms.includes("home:repair:approval")) {
					routeObj.children.push({
						title: "维修审批",
						icon: "el-icon-document-checked",
						name: "repairApproval",
						path: "/claimantManagement/repairApproval",
					});
				}
				if (this.perms.includes("home:repair:logisticsApproval")) {
					routeObj.children.push({
						title: "物流审批",
						icon: "el-icon-wind-power",
						name: "logisticsApproval",
						path: "/claimantManagement/logisticsApproval",
					});
				}
				if (this.perms.includes("home:repair:claimsLogistics")) {
					routeObj.children.push({
						title: "索赔物流",
						icon: "el-icon-truck",
						name: "claimantLogistics",
						path: "/claimantManagement/claimantLogistics",
					});
				}
				if (this.perms.includes("home:repair:expenseApproval")) {
					routeObj.children.push({
						title: "费用审批",
						icon: "el-icon-money",
						name: "expenseApproval",
						path: "/claimantManagement/expenseApproval",
					});
				}
				if (this.perms.includes("home:repair:returnVisit")) {
					routeObj.children.push({
						title: "回访",
						icon: "el-icon-service",
						name: "followUp",
						path: "/claimantManagement/followUp",
					});
				}

				if (this.perms.includes("home:repair:extendedWarrantyRecord")) {
					routeObj.children.push({
						title: "延保记录",
						icon: "el-icon-document",
						name: "extendedWarrantyRecord",
						path: "/claimantManagement/extendedWarrantyRecord",
					});
				}

				if (this.perms.includes("home:repair:settlement")) {
					routeObj.children.push({
						title: "结算信息",
						icon: "el-icon-bank-card",
						name: "repairSettle",
						path: "/claimantManagement/repairSettle",
					});
				}

				if (this.perms.includes("home:repair:replacedDeviceNumber")) {
					routeObj.children.push({
						title: "已换机机号",
						icon: "el-icon-monitor",
						name: "repairExchange",
						path: "/claimantManagement/repairExchange",
					});
				}
				menuArray.push(routeObj);
			}
			// 维修机型
			if (this.perms.includes("home:repair:model")) {
				menuArray.push({
					title: "维修机型",
					icon: "el-icon-receiving",
					name: "repairModel",
					path: "/claimantManagement/repairModel",
				});
			}
			// 送货地址
			if (this.perms.includes("home:repair:shippingAddress")) {
				menuArray.push({
					title: "送货地址",
					icon: "el-icon-map-location",
					name: "repairAdvance",
					path: "/claimantManagement/repairAdvance",
				});
			}

			this.menuList = menuArray;

			// 从登录页直接进详情页
			this.setDetail();

			// 刷新页面不自动跳转回左侧第一个菜单
			if (/claimantManagement/.test(this.$route.path) && this.$route.name != "claimantManagement") {
				return;
			}

			// 进入页面自动加载左侧第一个菜单
			if (menuArray.length > 0) {
				if (menuArray[0].children) {
					this.$router.replace({
						path: menuArray[0].children[0].path,
					});
				} else {
					this.$router.replace({
						path: menuArray[0].path,
					});
				}
			}
		},
		// 处理路由重复点击报错问题
		handleRepeatRoute() {
			this.className = "p1";
			this.defaultActivePath = this.$route.path;

			// 路由处理映射
			const routeHandlers = {
				repairRequestDetail: () => {
					const menuAction = this.$route.query.menuAction;
					const targetMenu = this.menuList.find((menu) => menu.name === menuAction);
					this.defaultActivePath = targetMenu?.path || this.defaultActivePath;
				},
				repairRequestAddEdit: () => {
					this.defaultActivePath = PATHS.REPAIR_REQUEST;
				},
				// 合并处理claim相关路由
				...["claimCreate", "claimDetail", "claimProcess", "claimLog"].reduce((acc, name) => {
					acc[name] = () => {
						this.defaultActivePath = this.claimRoute || window.sessionStorage.getItem("claimRoute");
					};
					return acc;
				}, {}),
			};

			// 执行处理或使用默认值
			routeHandlers[this.$route.name]?.();
		},
		// 从登录页直接进详情页
		setDetail() {
			const route = this.$route;
			if (route.name == "claimDetail" && route.query.menuAction) {
				// 映射关系,menuAction:对应权限
				const permMap1 = {
					1: "home:repair:normalRepair:apply",
					2: "home:repair:normalRepair:audit",
					3: "home:repair:normalRepair:shipping",
				};

				const perm = permMap1[route.query.menuAction] || "";

				if (this.perms.includes(perm)) {
					const permMap = {
						1: "claimApplicationList",
						2: "claimReviewList",
						3: "claimDeliveryList",
					};
					const claimRoute = `/claimantManagement/${permMap[route.query.menuAction]}`;
					this.claimRoute = claimRoute;
					window.sessionStorage.setItem("claimRoute", claimRoute);
				} else {
					this.$message.warning("当前用户没有权限");
				}
			}
		},
	},
};
</script>
<style>
.p1 {
	padding: 15px;
}
.p2 {
	padding: 0;
}
</style>
<style lang="scss" scoped>
.system-content {
	display: flex;
	box-sizing: border-box;
	padding-top: 20px;
	position: relative;
	.system-left {
		width: 170px;
		min-width: 170px;
		max-width: 170px;
		background-color: #fff;
		border-radius: 10px;
		box-sizing: border-box;
		padding-top: 25px;
		padding-right: 15px;
		min-height: calc(100vh - 180px);
		position: fixed;
		.title {
			height: 30px;
			font-size: 24px;
			margin-bottom: 10px;
			text-align: center;
		}
		.el-menu {
			border-right: none;
			border-radius: 10px;
			height: calc(100vh - 245px);
			overflow-y: auto;
			overflow-x: hidden;
			.el-menu-item {
				border-top-right-radius: 26px;
				border-bottom-right-radius: 26px;
			}
			.el-menu-item.is-active {
				background-color: #ecf5ff;
			}
		}
	}
	.system-right {
		flex: 1;
		background-color: #fff;
		border-radius: 10px;
		margin-left: 180px;
		box-sizing: border-box;
		max-width: calc(100% - 170px);
	}
}
.el-menu-item {
	padding-left: 0;
	i {
		width: 20px;
		height: 20px;
		display: inline-block;
		margin-right: 10px;
	}
	.ricoh-icon-user {
		width: 22px;
		height: 22px;
		background: url("~@/assets/images/yonghu.png") no-repeat;
		background-size: 19px 19px;
	}
}

.el-menu-item.is-active {
	.ricoh-icon-user {
		width: 22px;
		height: 22px;
		background: url("~@/assets/images/yonghu-1.png") no-repeat;
		background-size: 19px 19px;
	}
}

/* 调整滚动条宽度 */
::-webkit-scrollbar {
	width: 3px; /* 纵向滚动条宽度 */
	height: 6px; /* 横向滚动条高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
	background: #f1f1f1;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
	background: #888;
	border-radius: 3px;
}
</style>
